exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "div.main {\n  padding:1ex;\n  margin:1ex;\n  border: 2px silver solid;\n}\n\nbutton {\n  font-size: small;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/project-db-records-stats/project-db-records-stats.component.css
// module id = 398
// module chunks = 0